export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-0da17922',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
